module.exports = __webpack_public_path__ + "img/ancv.b1b2bbac.svg";